var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.flash.show)?_c('p',{staticClass:"absolute bottom-12 p-2 rounded bg-success shadow select-none flash"},[_vm._v(" "+_vm._s(_vm.$store.state.flash.message)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }